export default `
	images {
		filename
		height
		id
		size
		url(transform:heroHomePortrait)
		width
	}
`;
